import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { featureFlags } from '@/lib/env';
import { YearEndAdjustmentConfirmationSearchSchema } from './year-end-adjustment-confirmation/-zod-schema';
export const Route = createFileRoute('/_staff/labor-core/year-end-adjustment-confirmation')({
  beforeLoad: () => {
    // YEA 確認画面は 2 系統からの遷移を許可する:
    // - デモ用 mock: ENABLE_YEAR_END_ADJUSTMENT_OPERATION_PACKAGE
    // - 実 BE 連携の正規 YEA: NEW_FEATURE
    // どちらも無効なセッションでは直接 URL アクセスを packages 一覧へ戻す。
    if (!featureFlags.check('ENABLE_YEAR_END_ADJUSTMENT_OPERATION_PACKAGE') && !featureFlags.check('NEW_FEATURE')) {
      throw redirect({
        to: '/labor-core'
      });
    }
  },
  validateSearch: zodValidator(YearEndAdjustmentConfirmationSearchSchema)
});